import React from 'react';

export default function Footer() {
    return (
        <footer>
            <h5><a href="mailto:jcoyne824@gmail.com">jcoyne824@gmail.com</a></h5>
        </footer>
    )
}